import React, {FC} from 'react';
import messages from './messages';
import ProductDetailsSection from './product-details-section';
import Breadcrumbs from 'components/Common/Breadcrumb';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';

interface Props {}

const EditProductPage: FC<Props> = () => {
  const {t} = useTranslation();

  return (
    <div className="page-content">
      <Helmet>
        <title> {t(...messages.pageTitle())}</title>
      </Helmet>
      <Container fluid>
        <Breadcrumbs
          showHeading={false}
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {
              title: t(...messages.productsTitle()),
              path: '/dashboard/products',
            },
            {title: t(...messages.pageTitle()), path: '#'},
          ]}
        />
        <ProductDetailsSection />
      </Container>
    </div>
  );
};

export default EditProductPage;
